import { ParsedFormat } from "../FormatAndSizePreference.js";


export interface TechWithUpdatableSource {

    getCurrentFormat(): ParsedFormat;
    updateFormat(f: ParsedFormat): Promise<void>;

}


export class NativeVODPlayer implements TechWithUpdatableSource {


    private video: HTMLVideoElement;


    private loaded: boolean;

    public constructor(
        private currentFormat: ParsedFormat
    ) {
        this.loaded = false;
    }


    public attachVideoElement(v: HTMLVideoElement): NativeVODPlayer {

        if (!this.video) {
            this.video = v;
            return this;
        }

    }

    public load(): Promise<void> {
        //    this.video.src = 
        if (!this.loaded) {
            console.log("[AGGRO] Called load");
            this.video.src = this.currentFormat ? this.currentFormat.url : "";
            this.video.preload = "metadata";
            this.video.width = this.currentFormat.parsedSize.width;
            this.video.height = this.currentFormat.parsedSize.height;
            this.loaded = true;

        }
        return Promise.resolve();
    }

    public dispose() {
        console.log("[AGGRO] called dispose");
        if (this.video) this.video.src = "";
    }




    public play(): Promise<void> {
        return this.load().then(_ => {
            return this.video.play();
        });
    }

    getCurrentFormat(): ParsedFormat {
        return this.currentFormat;
    }

    reloadSource(keepCurrentTime: boolean): Promise<void> {
        const timing = keepCurrentTime ? this.video.currentTime : 0;
        this.video.src = this.currentFormat.url;
        this.video.width = this.currentFormat.parsedSize.width;
        this.video.height = this.currentFormat.parsedSize.height;
        this.video.load();
        this.video.currentTime = timing;
        return Promise.resolve();
    }

    updateFormat(f: ParsedFormat): Promise<void> {
        if (f && (!this.currentFormat ||
            this.currentFormat.url != f.url)) {
            console.log("[AGGRO] update format");
            const currentTime = this.video.currentTime;
            this.currentFormat = f;
            this.video.src = f.url;
            this.video.width = f.parsedSize.width;
            this.video.height = f.parsedSize.height;
            this.video.load();
            this.video.currentTime = currentTime;
            return Promise.resolve();

        }
        else return Promise.resolve();
    }


    hasBeenLoaded(): boolean {
        return this.loaded;
    }

}
